import { faSpinner } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { useDetectClickOutside } from "react-detect-click-outside";
import { useDebounce } from "usehooks-ts";

import { django } from "@/api";
import { useActiveEditor } from "@/hooks";

import styles from "./SyncedNodeSelect.module.scss";

export interface Result {
  room_name: string;
  block_id: string;
  text: string;
}

const splitRoomName = (input: string): { projectSlug: string; pageId: string } => {
  const pageId = input.slice(-21);
  const dotIndex = input.indexOf(".");
  const projectSlug = input.slice(dotIndex + 1, -22).replace("lateral-ldg-", "");
  return { projectSlug, pageId };
};

export const SyncedNodeSelect = ({
  visible,
  setVisible,
}: {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [results, setResults] = useState<Result[]>([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const inputRef = useRef<HTMLInputElement>(null);

  const { activeEditor } = useActiveEditor();

  const loadResults = async () => {
    setLoading(true);
    if (!query) {
      setResults([]);
      setLoading(false);
      return;
    }
    console.log("LOAD RES");
    const response = await django.get("editor/node/search/", {
      params: { format: "json", q: query.toLowerCase() },
    });
    setSelectedIndex(0);
    setResults(response.data);
    setLoading(false);
  };

  useEffect(() => {
    if (visible == true && inputRef.current) {
      inputRef.current.focus();
    }
  }, [visible, inputRef]);

  const queryDebounced = useDebounce(query, 500);
  useEffect(() => {
    loadResults();
  }, [queryDebounced]);

  const selectItem = (item: number) => {
    const result = results[item];
    console.log(activeEditor);
    console.log("SELELELELLELELE", results[item]);

    const selection = activeEditor?.view.state.selection;
    const range = selection?.ranges[0];
    console.log(result.room_name);
    const { projectSlug } = splitRoomName(result.room_name);

    activeEditor
      ?.chain()
      .focus()
      .insertContentAt(
        // @ts-ignore
        { from: range.$from.pos - 2, to: range.$to.pos },
        [
          {
            type: "listItem",
            attrs: {
              syncedBlockId: result.block_id,
              syncedBlockProject: projectSlug,
            },
            content: [{ type: "paragraph", content: [] }],
          },
          // {
          //   type: "paragraph",
          //   content: [],
          // },
          // {
          //   type: "paragraph",
          //   content: [],
          // },
        ]
      )
      .run();
    setVisible(false);
  };

  const onKeyDown = (e: React.KeyboardEvent) => {
    console.log(e.key);
    if (e.key == "ArrowUp") {
      e.preventDefault();
      if (selectedIndex == -1 || selectedIndex == 0) {
        return;
      }
      setSelectedIndex(selectedIndex - 1);
    }
    if (e.key == "ArrowDown") {
      e.preventDefault();
      if (selectedIndex == results.length - 1) {
        return;
      }
      setSelectedIndex(selectedIndex + 1);
    }
    if (e.key == "Enter") {
      selectItem(selectedIndex);
    }
    if (e.key == "Escape") {
      setVisible(false);
    }
  };

  const ref = useDetectClickOutside({ onTriggered: () => setVisible(false) });

  if (!visible) return <></>;

  return (
    <div className={styles.wrapper} ref={ref}>
      {loading ? (
        <div className={styles.loader}>
          <FontAwesomeIcon icon={faSpinner} spin />
        </div>
      ) : (
        <></>
      )}
      <input
        className={styles.input}
        autoFocus
        onKeyDown={onKeyDown}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Type to find a node"
        ref={inputRef}
      />
      {results.map((result, index) => (
        <div
          className={classNames(styles.result, {
            [styles.active]: selectedIndex == index,
          })}
          onClick={() => selectItem(index)}
          key={`syncednode-${index}`}
          title={result.text}
        >
          {result.text}
        </div>
      ))}
    </div>
  );
};
